import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  flex: 1;\n  min-width: 0;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  flex: 1;\n  min-width: 0;\n"])));
export var TextContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var templateObject_1, templateObject_2;
